// extracted by mini-css-extract-plugin
module.exports = {"causeList":"CauseList_causeList__CcIMf","logo":"CauseList_logo__m71mU"};